export const matchesBannerAudience = (
  audience: string,
  isFreemiumUser: boolean,
  isCompassEnabled: boolean
): boolean => {
  switch (audience) {
    case 'ratings_subscribers':
      return !isFreemiumUser && !isCompassEnabled;
    case 'compass_subscribers':
      return isCompassEnabled && !isFreemiumUser;
    case 'all_subscribers':
      return !isFreemiumUser;
    case 'public_users':
      return isFreemiumUser;
    case 'all_users':
      return true;
    default:
      return false;
  }
};
